import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { UserService } from '../../services';

@Component({
  selector: 'app-verify-email',
  imports: [CommonModule, RouterLink],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './verify-email.html',
  styleUrl: './verify-email.css',
})
export class VerifyEmail implements OnInit {
  loading = true;
  success = false;
  route = inject(ActivatedRoute);
  userService = inject(UserService);
  http = inject(HttpClient);
  animationUrl = './../assets/animations/no_verified.json';
  title = 'Usuario no verificado';
  buttonText = 'Volver';

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    console.log('[VerifyEmail] Component loaded. Token present:', !!token, 'Token length:', token?.length);

    if (token) {
      const url = `${this.userService.baseUrl}/api/v1/Auth/activate`;
      console.log('[VerifyEmail] Calling activate API at:', url);
      this.userService.activateUser({ token }).subscribe({
        next: () => {
          this.success = true;
          this.loading = false;
          this.animationUrl = './../assets/animations/user_confirmed.json';
          this.title = '¡Tu usuario ha sido activado con éxito!';
          this.buttonText = 'Iniciar Sesión';
        },
        error: (err) => {
          console.error('Error activating user:', err);
          this.success = false;
          this.loading = false;
        },
      });
    } else {
      this.success = false;
      this.loading = false;
    }
  }
}
